import React from "react";
import { LuFolderCog } from "react-icons/lu";
import { Button } from "primereact/button";
import { useState, useEffect, useRef, useCallback } from "react";
import "../Feedbacks/Feedback.scss";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Rating } from "primereact/rating";
import "primereact/resources/themes/lara-light-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import { Checkbox } from "primereact/checkbox";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { InputText } from "primereact/inputtext";
import axios from "axios";
import DeletePopup from "../Components/DeletePopup";
import {
  deleteFeedbackurl,
  deleteSingleFeedback,
  getFeedbackurl,
} from "../../Services/BackendUrl";
import { Dialog } from "primereact/dialog";
import { encryptedAuth } from "../../Services/EncryptData";

const Feedback = ({ setIsExporting }) => {
  const [usersFeedbacks, setUsersFeedbacks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showCheckboxes, setShowCheckboxes] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [customers, setCustomers] = useState([]);
  const [showDeletePopup, setShowDeletePopup] = useState(false);
  const [selectedLocalid, setSelectedLocalid] = useState(null);
  const [isMultipleDelete, setIsMultipleDelete] = useState(false);
  const actionBtnRef = useRef(null);
  const [showDataPopup, setShowDataPopup] = useState(false)

  const fetchFeedbacks = useCallback(async () => {
    try {
      const response = await axios.get(getFeedbackurl, {
        headers: {
          Authorization : `Encrypted ${encryptedAuth}`
        },
      });
      setUsersFeedbacks(response.data.feedbacks);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching feedback users:", error);
      setLoading(false);
    } finally {
      setIsExporting(false);
    }
  }, [setIsExporting]);
  useEffect(() => {
    fetchFeedbacks();
  }, [fetchFeedbacks]);

  useEffect(() => {
    if (usersFeedbacks.length > 0) {
      const formatted = usersFeedbacks.map((customer, index) => ({
        ...customer,
        localid: (index + 1).toString().padStart(2, "0"),
      }));
      setCustomers(formatted);
    }
  }, [usersFeedbacks]);

  const deleteFeedback = (LocalId) => {
    setShowDeletePopup(true);
    setSelectedLocalid(LocalId);
    setIsMultipleDelete(false);
  };
  const deleteMultipleFeedback = () => {
    setIsMultipleDelete(true);
    setShowDeletePopup(true);
  };

  const confirmDelete = async () => {
    try {
      const customer = customers.find((c) => c.localid === selectedLocalid);
      if (!customer) {
        console.error("Customer not found for local ID:", selectedLocalid);
        return;
      }
      const serverId = customer.id;
      const response = await axios.delete(
        `${deleteSingleFeedback}/${serverId}`,
        {
          headers: {
            Authorization : `Encrypted ${encryptedAuth}`
          },
        }
      );
      if (response.data.message === `Feedback with id ${serverId} deleted.`) {
        setCustomers((prevCustomers) =>
          prevCustomers.filter((customer) => customer.id !== serverId)
        );
      }
    } catch (error) {
      console.error("Error deleting feedback user:", error.response?.data || error.message);
    } finally {
      setShowDeletePopup(false);
    }
  };

  const confirmMultipleDelete = async () => {
    if (showCheckboxes) {
      const selectedServerIds = customers
        .filter((c) => selectedRows.includes(c.localid))
        .map((c) => String(c.id));

      if (selectedServerIds.length === 0) {
        alert("No items selected for deletion.");
        return;
      }

      try {
        const response = await axios.post(
          deleteFeedbackurl,
          { ids: selectedServerIds },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization : `Encrypted ${encryptedAuth}`
            },
          }
        );

        if (response.data.message) {
          const remainingCustomers = customers.filter(
            (customer) => !selectedServerIds.includes(String(customer.id))
          );

          const reindexed = remainingCustomers.map((c, i) => ({
            ...c,
            localid: (i + 1).toString().padStart(2, "0"),
            checkbox: false,
          }));

          setCustomers(reindexed);

          setSelectedRows([]);
          setShowCheckboxes(false);
        }
      } catch (error) {
        console.error("Error deleting feedback users:", error.response?.data || error.message);
      } finally {
        setShowDeletePopup(false);
      }
    } else {
      const updated = customers.map((c) => ({ ...c, checkbox: true }));
      setCustomers(updated);
      setShowCheckboxes(true);
    }
  };

  const ratingBodyTemplate = (customer) => {
    return <Rating value={customer.starRating} readOnly cancel={false} />;
  };

  const showCustomerData = (rowData) => {
    setSelectedCustomer(rowData);
    setShowDataPopup(true);
  };

  const actionBodyTemplate = (rowData) => {
    return (
      <div className="action-column">
        <Button icon="pi pi-eye" onClick={() => showCustomerData(rowData)} />
        <Button
          icon="pi pi-trash"
          onClick={() => deleteFeedback(rowData.localid)}
        />
      </div>
    );
  };

  const checkboxBodyTemplate = (rowData) => {
    if (!rowData.checkbox) return null;

    return (
      <Checkbox
        checked={selectedRows.includes(rowData.localid)}
        onChange={(e) => {
          const isChecked = e.checked;

          setSelectedRows((prevSelected) => {
            const newSelected = isChecked
              ? [...prevSelected, rowData.localid]
              : prevSelected.filter((localid) => localid !== rowData.localid);

            const updatedCustomers = customers.map((c) =>
              c.localid === rowData.localid ? { ...c, isChecked: isChecked } : c
            );
            setCustomers(updatedCustomers);

            const updatedFiltered = filteredCustomers.map((c) =>
              c.localid === rowData.localid ? { ...c, isChecked: isChecked } : c
            );
            setFilteredCustomers(updatedFiltered);

            return newSelected;
          });
        }}
      />
    );
  };

  const customerFields = [
    { field: "localid", header: "S.No" },
    { field: "fullName", header: "Name" },
    { field: "profession", header: "Profession" },
    { field: "starRating", header: "Rating", body: ratingBodyTemplate },
    { field: "createdAt", header: "Submitted On" },
    { field: "actions", header: "Actions", body: actionBodyTemplate },
  ];

  const fullCustomer = customers.find(
    (c) => c.localid === selectedCustomer?.localid
  );
  const [searchText, setSearchText] = useState("");
  const [filteredCustomers, setFilteredCustomers] = useState(customers);

  const handleSearch = (e) => {
    const value = e.target.value.toLowerCase();
    setSearchText(value);
  };

  const filteredData =
    searchText.trim() === ""
      ? customers
      : customers.filter((customer) => {
        const nameMatch = customer.fullName
          ?.toLowerCase()
          .includes(searchText);
        const professionMatch = customer.profession
          ?.toLowerCase()
          .includes(searchText);

        const ratingMatch =
          !isNaN(searchText) && customer.starRating === Number(searchText);

        const starsMatch =
          searchText.startsWith("*") &&
          "*".repeat(customer.starRating) === searchText;
        return (
          nameMatch ||
          professionMatch ||
          ratingMatch ||
          starsMatch
        );
      });

  return (
    <>
      <div className="admin-feedback-container">
        <div className="fb-nav-container">
          <div className="fb-icon-title">
            <div className="fb-icon-box">
              <LuFolderCog className="fb-icon" />
            </div>
            <div className="fb-title-box">Feedback</div>
          </div>
          <div className="fb-navoptions-container">
            <div className="searchbox-container">
              <IconField iconPosition="left">
                <InputIcon className="pi pi-search" />
                <InputText
                  placeholder="Search here"
                  value={searchText}
                  onChange={handleSearch}
                />
              </IconField>
            </div>
          </div>
        </div>

        <div className="fb-table-container">
          <DataTable
            value={filteredData}
            scrollable
            style={{ width: "100%" }}
            className="fb-datatable"
            loading={loading}
            paginator
            rows={5}
            emptyMessage="No available options"
            paginatorTemplate={{
              layout: "PrevPageLink PageLinks NextPageLink",
              PrevPageLink: (options) => {
                return (
                  <button
                    type="button"
                    className="p-paginator-prev p-paginator-element p-link"
                    onClick={options.onClick}
                    disabled={options.disabled}
                  >
                    <i
                      className="pi pi-angle-left"
                      style={{ marginRight: "5px" }}
                    ></i>
                    Back
                  </button>
                );
              },
              NextPageLink: (options) => {
                return (
                  <button
                    type="button"
                    className="p-paginator-next p-paginator-element p-link"
                    onClick={options.onClick}
                    disabled={options.disabled}
                  >
                    Next
                    <i
                      className="pi pi-angle-right"
                      style={{ marginLeft: "5px" }}
                    ></i>
                  </button>
                );
              },
            }}
          >
            {customerFields.map((col, index) => (
              <Column
                key={index}
                field={col.field !== "actions" ? col.field : undefined}
                header={col.header}
                body={
                  col.field === "localid"
                    ? (rowData, options) => (
                      <span>
                        {(options.rowIndex + 1).toString().padStart(2, "0")}
                      </span>
                    )
                    : col.field === "createdAt"
                      ? (rowData) => {
                        const date = new Date(rowData.createdAt);
                        const formatted = date
                          .toLocaleDateString("en-GB")
                          .replace(/\//g, "-");
                        return <span>{formatted}</span>;
                      }
                      : col.body
                }
                headerStyle={
                  col.field === "localid"
                    ? {
                      backgroundColor: "transparent",
                      color: "#fff",
                      border: "#7FC5FF26",
                      borderTopLeftRadius: "25px",
                      borderBottomLeftRadius: "25px",
                      padding: "25px 10px 25px 10px",
                      textAlign: "center",
                    }
                    : {
                      backgroundColor: "transparent",
                      color: "#fff",
                      border: "#7FC5FF26",
                    }
                }
              />
            ))}

            <Column
              header={
                <Button
                  style={{
                    backgroundColor: "transparent",
                    border: "transparent",
                  }}
                  icon={
                    <i
                      className={`pi ${showCheckboxes ? "pi-trash" : "pi-pencil"
                        }`}
                      style={{
                        color: showCheckboxes ? "#FF4649" : "inherit",
                      }}
                    />
                  }
                  ref={actionBtnRef}
                  onClick={() => {
                    if (showCheckboxes) {
                      const anyChecked = customers.some((c) => c.isChecked);

                      if (anyChecked) {
                        deleteMultipleFeedback();
                      } else {
                        setShowCheckboxes(false);

                        const updated = customers.map((c) => ({
                          ...c,
                          checkbox: false,
                          isChecked: false,
                        }));

                        setCustomers(updated);
                        setSelectedRows([]);
                      }
                    } else {
                      const updated = customers.map((c) => ({
                        ...c,
                        checkbox: true,
                      }));
                      setCustomers(updated);
                      setShowCheckboxes(true);
                      actionBtnRef.current.style.color = "white";
                    }
                  }}
                />
              }
              body={checkboxBodyTemplate}
              headerStyle={{
                backgroundColor: "transparent",
                color: "#fff",
                border: "#7FC5FF26",
                borderTopRightRadius: "25px",
                borderBottomRightRadius: "25px",
              }}
            />
          </DataTable>
        </div>

        <DeletePopup
          visible={showDeletePopup}
          onHide={() => {
            setShowDeletePopup(false);
            setShowCheckboxes(false);
            const updated = customers.map((c) => ({
              ...c,
              checkbox: false,
              isChecked: false,
            }));
            setCustomers(updated);
            const updatedFiltered = filteredCustomers.map((c) => ({
              ...c,
              checkbox: false,
              isChecked: false,
            }));
            setFilteredCustomers(updatedFiltered);
            setSelectedRows([]);
          }}
          onConfirm={isMultipleDelete ? confirmMultipleDelete : confirmDelete}
        />
      </div>
      {selectedCustomer && (
        <div className="feedback-show-container">
          <Dialog header={(
            <div className="customer-details-header">
              <div className="customer-namepofess">
                <h2>{selectedCustomer.fullName.toUpperCase()}</h2>
                <p>{selectedCustomer.profession}</p>
              </div>
            </div>
          )}
            visible={showDataPopup} style={{ width: '45vw',height:"40vh" }} onHide={() => { if (!showDataPopup) return; setShowDataPopup(false); }} appendTo="self">
            <div className="customer-body-container" style={{marginTop:"20px"}}>
              <div className="customer-submittedon" style={{paddingLeft:"25px"}}>
                <p className="submittedon-title">
                  <strong>Submitted On</strong>
                </p>
                <p className="submittedon">
                  {new Date(selectedCustomer.createdAt)
                    .toLocaleDateString("en-GB")
                    .replace(/\//g, "-")}
                </p>
              </div>
              <div className="customer-rating" style={{marginLeft:'300px'}}>
                <p>
                  <strong>Rating</strong>
                </p>
                <div className="stars">
                  {[...Array(5)].map((_, i) => (
                    <i
                      key={i}
                      className="pi pi-star-fill"
                      style={{
                        color:
                          i < selectedCustomer.starRating
                            ? "#0B3750"
                            : "#bfc2c8ff",
                            marginRight:"4px"
                          
                
                      }}
                    ></i>
                  ))}
                </div>
              </div>
            </div>
            <div className="customer-feedback" style={{marginTop:"20px",paddingLeft:"25px"}}>
              <p className="feedback-title">
                 <strong>Feedback</strong>
               </p>
               <p className="feedback">{fullCustomer?.message}</p>
             </div>
            
          </Dialog>
        </div>
      )
      }
    </>
  );
};

export default Feedback;
